/* src/app/content-detail/content-detail.component.scss */
/*# sourceMappingURL=content-detail.component.css.map */
